import React from 'react';
import CollaboratorCard from './CollaboratorCard';
import { useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { APITypes } from '../../../../../primary-record-types';
import { ContentStack } from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('care-team-collaborators', {
    collaborators: 'Care Team Collaborators',
});

export type CareTeamCollaboratorsOwnProps = {
    profileId: string;
    careTeamCollaborators: APITypes.medicalProfileService.CareTeamCollaborator[];
};

export type CareTeamCollaboratorsProps = CareTeamCollaboratorsOwnProps;

const CareTeamCollaborators: React.FC<CareTeamCollaboratorsProps> = ({ profileId, careTeamCollaborators }) => {
    const navigation = useProfilesTabNavigation();

    if (!careTeamCollaborators || careTeamCollaborators.length === 0) return null;

    return (
        <ContentStack>
            <Text variant="h4">{intl('collaborators')}</Text>
            {(careTeamCollaborators || [])
                .filter((_) => _.type === 'user-collaborator')
                .map((careTeamCollaborator) => {
                    return (
                        <CollaboratorCard
                            key={careTeamCollaborator.careTeamMemberId}
                            collaborator={
                                careTeamCollaborator as APITypes.medicalProfileService.MedicalProfileUserCollaborator
                            }
                            medicalProfileId={profileId}
                            onSelect={() => {
                                navigation.navigate('collaborator', {
                                    profileId: profileId,
                                    collaboratorId: careTeamCollaborator.careTeamMemberId,
                                });
                            }}
                        />
                    );
                })}
        </ContentStack>
    );
};

export default React.memo(CareTeamCollaborators);
